import {Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'li3-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent implements OnInit {
  @Input() label: string;
  @Input() placeholder: string;
  @Input() type: string;
  @Input() name: string;
  @Input() value = '';
  @Input() id: string;
  @Input() testId: string;
  @Input() maxLength: string;
  @Input() isInvalid: boolean;
  @Input() disabled: boolean;
  @Input() errorMessage: string;
  @Input() errorMessageTestId: string;
  @Output() focused = new EventEmitter();
  @Output() changed = new EventEmitter();
  @Output() blurred = new EventEmitter();

  isFocused = false;

  constructor() {
  }

  ngOnInit() {
  }

  onFocus() {
    this.focused.emit();
    this.isFocused = true;
  }

  onChange(value) {
    this.changed.emit(value);
  }

  onBlur() {
    this.blurred.emit();
    this.isFocused = false;
  }
}
